export const ssoLogin = {
  loading: 'Hold on a J/s while we validate your SSO token…',
  welcome: 'Welcome back to your Arcadia dashboard.',
  loginPrompt: 'Login via SSO',
};
